import { render, staticRenderFns } from "./ResourceFilters.vue?vue&type=template&id=7f33db4a&"
import script from "./ResourceFilters.vue?vue&type=script&lang=js&"
export * from "./ResourceFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports